import { Component, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';


@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, NgIf, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  showButton = false;

  constructor() { }

  // Function to scroll to the top of the page
  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  // Listen to the scroll event
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const yOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.showButton = yOffset > 500;
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }
}
